// @flow
import * as React from 'react';
import styled from 'styled-components';
import colors from '../../../assets/css/colors';
import { TeamUserAvatar } from '../../../components';

const pickBackgroundColor = ({ is_active, this_is_you, is_past_pick }) => {
	if(is_active) {
		return colors.nrlGreen;
	}

	if(this_is_you) {
		return colors.lightGreen;
	}

	if(is_past_pick) {
		return '#F6F6F6';
	}

	return '#FFF';
};

const DraftTeamListOrderItemWrapper = styled.div`
	z-index: 1;
	width: 80px;
	height: 80px;
	background: ${pickBackgroundColor};
	opacity: ${({ is_past_pick }) => is_past_pick ?  0.9 : 1};
`;

const TeamName = styled.div`
	padding-top: 0.2em;
	color: ${colors.nrlDarkGreen};
	font-size: 10px;
	line-height: 1.4;
	font-weight: bold;
	white-space: nowrap;
	margin: 0 4px;
	overflow: hidden;
	text-overflow: ellipsis;
`;

const FirstName = styled.div`
	color: ${colors.darkGrey};
	font-size: 10px;
`;

const TeamUserAvatarStyled = styled(TeamUserAvatar)`
	height: 30px;
	width: 30px;
	border-radius: 50%;
	object-fit: cover;
	margin: 0 auto;
`;

const PickNumber = styled.div`
	margin: 0.5em auto 0;
	font-size: 10px;
	line-height: 1.4;
	font-weight: bold;
	color: ${colors.nrlDarkGreenHover};
`;

const UsersPick = styled.div`
	font-size: 12px;
	line-height: 1.5;
	padding-top: 3px;
	padding-bottom: 5px;
	font-weight: bold;
`;

type Props = {
	team_name?: string,
	first_name?: string,
	is_your_pick?:boolean,
	user_id:number,
	pick_number:number,
	this_is_you?:boolean,
	is_past_pick?:boolean,
	current_pick_number?:number
};

const content = ({ is_your_pick, this_is_you, team_name, first_name }) => {
	if(is_your_pick) {
		return	<UsersPick> Your pick! </UsersPick>;
	}

	if(this_is_you) {
		return <UsersPick>This is you</UsersPick>;
	}

	return (
		<div>
			<TeamName>
				{team_name}
			</TeamName>
			<FirstName>
				{first_name}
			</FirstName>
		</div>
	);
};

const DraftTeamListOrderItem = ({
	team_name,
	first_name,
	is_your_pick,
	user_id,
	pick_number,
	current_pick_number,
	this_is_you,
	is_past_pick
}: Props) => (
	<DraftTeamListOrderItemWrapper
		is_active={pick_number === current_pick_number}
		this_is_you={this_is_you}
		is_past_pick={is_past_pick}
	>

		{ content({ is_your_pick, this_is_you, team_name, first_name }) }

		<TeamUserAvatarStyled user_id={user_id} />
		<PickNumber>
			{pick_number}
		</PickNumber>
	</DraftTeamListOrderItemWrapper>
);

export default DraftTeamListOrderItem;


// WEBPACK FOOTER //
// ./src/pages/league/liveDraft/draftTeamListOrderItem.js